<template>
    <div class="form">
        <h4 class="step-title my-1">
            How long have you been currently insured for?
        </h4>
        <div class="step-content d-flex flex-column flex-md-row">
            <button-list v-bind:items="insuranceLengths" v-bind:onclick="complete"></button-list>
        </div>
    </div>
</template>

<script>
    import ButtonList from "./shared/ButtonList.vue"

    export default {
        name: "InsuranceLength",
        components: {
            ButtonList
        },
        data: function() {
            return {
                insuranceLengths: [
                    { text: "Less than 6 months", value: "LessThanSixMonths" },
                    { text: "6 months to 1 year", value: "SixMonthsOrMore" },
                    { text: "More than 1 year", value: "OneYearOrMore" }
                ]
            }
        },
        props: {
            lead: Object
        },
        methods: {
            complete: function(insuranceLength) {
                this.lead.insuranceLength = insuranceLength;
                this.$emit("complete", this.$options.name, insuranceLength);
            }
        }
    }
</script>
